import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import moment from 'moment-timezone';

import { TooltipPosition } from '../../tooltip/tooltip-inner.component';
import { ComponentVariant, Variants } from '../../variant/variant';
import { TimeAgoPipe } from '../pipes/timeago.pipe';

type RtTimeAgoOptions = Parameters<TimeAgoPipe['transform']>[1];

@Component({
  selector: 'rt-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
})
export class DateComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'small', 'large', 'left-align', 'color-red'],
  ];
  @ComponentVariant(DateComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public time: number | string;
  @Input() public tiny: boolean = false;
  @Input() public prefix: string | undefined;
  @Input() public tooltipPosition: TooltipPosition = 'above';
  @Input() public colorDarkest: boolean = false;

  public readonly amDateFormatPattern: string = 'lll';
  public timeAgoOptions: RtTimeAgoOptions = undefined;

  public ngOnChanges(): void {
    this.timeAgoOptions = this.getTimeAgoOptions();
  }

  private getTimeAgoOptions(): RtTimeAgoOptions {
    const isFuture = moment(this.time).isAfter(moment());

    return this.tiny ? { omitSuffix: !isFuture } : undefined;
  }
}
